module.exports = __webpack_public_path__ + "static/media/maze-balls.85341e7b.png";